import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { space } from '@synoptic/ui-kit/tokens.ts';
import { style } from '@vanilla-extract/css';

export const streamFiltersContainer = style([
  {
    display: 'flex',
    gap: space.s8,
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    marginTop: -space.s16,
  },
  responsiveStyle({
    mobile: {
      marginBottom: space.s8,
    },
    tablet: {
      marginBottom: 0,
    },
  }),
]);

export const streamFilterTriggerContainer = style([
  {
    flex: '1 1 0',
    maxWidth: 180,
  },
]);

export const streamFilterTrigger = style([
  {
    width: '100%',
  },
]);
